import style from "./forgotpassword.module.css";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import appLoaderAction from '../../redux/action/app-loader-action';
import notifyUtitls from '../../utils/notify-utils';
import { Form, Input, Button, Row, Col } from "antd";
import ForgotPasswordDialog from "./ForgotPasswordDialog";

const ForgotPassword = () => {
  const dispatch = useDispatch();
  const [isShowForgotPasswordDialog, setIsShowForgotPasswordDialog] = useState(false);
  
  const onCancel= () => {
		setIsShowForgotPasswordDialog(false);
	};

  const onSubmitComplete = () => {
    setIsShowForgotPasswordDialog(false);
	};

  const onClickDialog = () => {
    try {
        dispatch(appLoaderAction.enable());
        setIsShowForgotPasswordDialog(true);
        dispatch(appLoaderAction.disale());
    } catch (err) {
        dispatch(appLoaderAction.disale());
        notifyUtitls.error(err);
    }
  }

  return (
    <div className="bg-gray">
      <div className="container h-100">
        <Row className="center-screen">
          <Col xs={24} sm={24} md={18} lg={14} xl={14}>
            <div className={style.content_forgotpass}>
              <Row>
                {/* <Col xs={0} sm={0} md={0} lg={8} xl={10}>
                  <div className={style.bg_forgotpass}>
                    <img src="/assets/icon-lock.png" style={{height:"140"}}  />
                  </div>
                </Col> */}
                <Col span={24}>
                  <div className={style.forgotpass_detail}>
                  <div className={style.bg_forgotpass}>
                    <img src="/assets/icon-lock.png" style={{height:"140"}}  />
                  </div>
                    <h3 style={{ fontWeight: "400" }}>ตั้งรหัสผ่านใหม่</h3>
                    <p>คุณสามารถตั้งรหัสผ่านใหม่ได้โดยการกดปุ่มด้านล่างนี้</p>
                    <Form
                      name="basic"
                      layout="vertical"
                      className="my-3"
                      labelCol={{
                        span: 24,
                      }}
                      wrapperCol={{
                        span: 24,
                      }}
                    >
                      <Button type="primary" onClick={onClickDialog}>ตั้งรหัสผ่านใหม่</Button>
                      {/* <div className="d-flex  align-items-center">
                        <span className="me-1 text-gray ">Login with</span> <div className="button-google"><img src="/assets/google-icon.jpg" className="img-fluid" /></div>
                      </div> */}
                    </Form>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>

        <ForgotPasswordDialog 
          isShow={isShowForgotPasswordDialog}
          onCancel={onCancel}
          onSubmitComplete={onSubmitComplete}
          ></ForgotPasswordDialog>
      </div>
    </div>
  );
};

export default ForgotPassword;
